import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import * as components from './';

class ClientRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path="/clients"
          component={components.ClientListContainer}
        />
        <Route
          exact
          path="/clients/new"
          component={components.ClientEditContainer}
        />
        <Route
          exact
          path="/clients/edit/:id"
          component={components.ClientEditContainer}
        />
        <Route
          exact
          path="/clients/:id"
          component={components.ClientDetailContainer}
        />
      </Switch>
    );
  }
}

export default ClientRoutes;



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientRoutes.js